import React from 'react';
import working from './img/working.png'
import RightButtons from './rightButtons';
import api from './apiConnector'


class Tarifs extends React.Component {

    constructor(props) {
        super(props)
        this.state = { waiting:false }
    }

    resync() {
        this.setState({waiting:true})
        const me = this
        api.post({
            action:'get_devis',
            resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
            id:this.props.devis._id.$oid
        },
        ()=>{
            me.setState({waiting:false})
        })
    }

    renderAccount() {
        const devis = this.props.devis
        const warranty = devis.getWarranty()
        const frais = parseFloat(devis.params.frais)

        if ( devis.params.periodicite && warranty ) {
            const optionField = ( devis.params.periodicite=='M' )?'Z_MTMOP':'Z_MTAOP'
            return <table className="tarifs_account">
                <tbody>
                <tr><td><label>Formule&nbsp;:&nbsp;<span>{warranty.Z_FORM} : {warranty.ZZ0_LIBFOR}</span></label></td>
                <td><label>Périodicité&nbsp;:&nbsp;<span>{(devis.params.periodicite=='M')?'Mensuel':'Annuel'}</span></label></td>
                </tr>
                <tr>
                    
                {(devis.params.periodicite=='A')
                    ? <td><label>Annuel sans options&nbsp;:&nbsp;<span>{warranty.Z_MTAN}</span></label></td>
                    : <td><label>Mensuel sans options : Acompte&nbsp;:&nbsp;<span>{devis.fancyPrice(2*warranty.Z_MTMENS+frais)}</span> puis par mois : <span>{devis.fancyPrice(warranty.Z_MTMENS)}</span> à partir du 3ème mois.</label></td> 
                }   
                <td></td>
                </tr>
                <tr>{devis.getOptions().map( option => <td key={option.Z_CODOPT}><label>Option {option.ZZ0_LIBOPT}&nbsp;:&nbsp;<span>{devis.fancyPrice(option[optionField])}</span></label></td> )}</tr>
                </tbody>
            </table>
        }
        return <></>
    }

    render() {

        const devis = this.props.devis
        const isMoto = devis.type == 'moto'
        const maxance = devis.getMaxance().setFancy('-',' €')
        const hasMaxance = maxance.hasTarifs()
        const hasSolly = devis.hasSollyTarifs()
        const solly = hasSolly ? devis.solly_tarifs : false
        const axa = devis.getAxa().setFancy('-',' €')
        const hasAxa = axa.hasAxa()
        const fma = devis.getFma().setFancy('-',' €')
        const hasFma = fma.hasFma()

        const frais = devis.frais()
        const fraisSup = devis.getValue('frais_sup','0.00')
        const rows = (isMoto?['M2','M3','M4','M7']:['L1','L2','L3']).map(
            zForm=>{
                const row = (( !devis.params.error )&& devis.params.warranties.find( r => r.Z_FORM == zForm ) )|| {
                    Z_FORM:zForm, ZZ0_LIBFOR: Tarifs.xenaWarranties[zForm], Z_MTAN:0, Z_MTSEM:0, Z_MTMENS:0
                }
                const sollyMensuel = ( hasSolly && solly[zForm].mensuel )? parseFloat(solly[zForm].mensuel) : 0
                const sollyAcompte = ( hasSolly && solly[zForm].acompte )? parseFloat(solly[zForm].acompte) : 0
                return <React.Fragment key={zForm}><tr>
                    <td className="ttitle" colSpan="3"><b>({zForm})</b> {row.ZZ0_LIBFOR.replace('?','é')}</td>
                </tr><tr>
                    <td className="ttarif">{devis.fancyPrice(row.Z_MTAN,' €')}
                        {hasSolly ? <span className="solly">{solly[zForm].annuel ? <> / {devis.fancyPrice(solly[zForm].annuel)} € </> : ''}</span> : ''}
                        {hasMaxance ? <span className="maxance"> / {maxance.fancyPrice(maxance.setFormuleFromXena(zForm).setFractionnement('A').coutTotal())}</span>:<></>}
                        {hasAxa ? <span className="axa"> / {axa.fancyPrice(axa.setFormuleFromXena(zForm).setFractionnement('A').coutTotal())}</span>:<></>}
                        {hasFma ? <span className="fma"> / {fma.fancyPrice(fma.setFormuleFromXena(zForm).setFractionnement('A').coutTotal())}</span>:<></>}
                    </td>
                    {hasMaxance?<td className="ttarif">
                        <span className="maxance">{maxance.fancyPrice(maxance.setFormuleFromXena(zForm).setFractionnement('A').acompte())}</span>
                    </td>:<></>
                    }
                    {(hasAxa||hasFma)?<td className="ttarif">
                        {devis.fancyPrice(row.Z_MTMENS ? (parseFloat(row.Z_MTMENS)*12+frais) : 0,' €')}
                        {hasAxa && <span className="axa"> / {axa.fancyPrice(axa.setFormuleFromXena(zForm).setFractionnement('M').coutTotal())}</span>}
                        {hasFma && <span className="fma"> / {fma.fancyPrice(fma.setFormuleFromXena(zForm).setFractionnement('M').coutTotal())}</span>}
                    </td>:<></>
                    }
                    
                    <td className="ttarif">{devis.fancyPrice(row.Z_MTMENS ? (parseFloat(row.Z_MTMENS)+frais/12) : 0,' €')}
                        {hasSolly ? <span className="solly">{solly[zForm].mensuel ? <> / {devis.fancyPrice((sollyAcompte+11*sollyMensuel)/12)} € </> : ''}</span> : ''}
                        {hasMaxance ? <span className="maxance"> / {maxance.fancyPrice(maxance.setFormuleFromXena(zForm).setFractionnement('M').coutTotal()*0.0834)}</span>:<></>}
                        {hasAxa ? <span className="axa"> / {axa.fancyPrice(axa.setFormuleFromXena(zForm).setFractionnement('M').echeance())}</span>:<></>}
                        {hasFma ? <span className="fma"> / {fma.fancyPrice(fma.setFormuleFromXena(zForm).setFractionnement('M').coutTotal()/12)}</span>:<></>}
                    </td>
                    <td className="ttarif">{devis.fancyPrice(row.Z_MTMENS ? 2*row.Z_MTMENS+frais : 0,' €')}
                        {hasSolly ? <span className="solly">{solly[zForm].mensuel ? <> / {devis.fancyPrice(sollyAcompte)} € </> : ''}</span> : ''}
                        {hasMaxance ? <span className="maxance"> / {maxance.fancyPrice(maxance.setFormuleFromXena(zForm).setFractionnement('M').acompte())}</span>:<></>}
                        {hasAxa ? <span className="axa"> / {axa.fancyPrice(axa.setFormuleFromXena(zForm).setFractionnement('M').echeance())}</span>:<></>}
                        {hasFma ? <span className="fma"> / {fma.fancyPrice(fma.setFormuleFromXena(zForm).setFractionnement('M').comptant())}</span>:<></>}
                    </td>
                    <td className="ttarif">{devis.fancyPrice(row.Z_MTMENS,' €')}
                        {hasSolly ? <span className="solly">{solly[zForm].mensuel ? <> / {devis.fancyPrice(sollyMensuel)} € </> : ''}</span> : ''}
                        {hasMaxance ? <span className="maxance"> / {maxance.fancyPrice(maxance.setFormuleFromXena(zForm).setFractionnement('M').echeance())}</span>:<></>}
                        {hasAxa ? <span className="axa"> / {axa.fancyPrice(axa.setFormuleFromXena(zForm).setFractionnement('M').echeance())}</span>:<></>}
                        {hasFma ? <span className="fma"> / {fma.fancyPrice(fma.setFormuleFromXena(zForm).setFractionnement('M').mensuel())}</span>:<></>}
                    </td>
                </tr>
                </React.Fragment>
            }
        )

        return <React.Fragment>
            {this.renderAccount()}
            { this.props.devis.synchronized ? ''
            : <a onClick={this.resync.bind(this)}><img className="working" src={working}/> Ce dossier est en cours de modification. Cliquer ici pour re-contacter xenassur et éditer un nouveau devis</a> }
            <p className="details_head">
               <label>Montant des frais de dossier</label> : {frais} € {(fraisSup!='0.00')?<>: {devis.getValue('frais',0)} € de frais de base et supplément de {devis.getValue('frais_sup',0)} €.</>:<></>}
               {hasMaxance?<><br/>
                <label className="maxance">Maxance mensuel</label> : Non récurrents {maxance.fancyPrice(maxance.fraisComptants.M)} ; A terme {maxance.fancyPrice(maxance.fraisTermes.M)} <br/>
                <label className="maxance">Maxance annuel</label> : Non récurrents {maxance.fancyPrice(maxance.fraisComptants.A)} ; A terme {maxance.fancyPrice(maxance.fraisTermes.A)}
               </>:<></>}
            </p>
            <p className="solly">
                {( devis.solly_validated < 0 ) ? <><b>Erreur Solly - </b> {devis.solly_error}</> : ''}
            </p>
            <p className="maxance">
                {( maxance.error )? <><b>Erreur Maxance - </b> {maxance.error}</> : ''}
            </p>
            <p className="maxance">
                {( axa.error )? <><b>Erreur Axa - </b> {axa.error}</> : ''}
            </p>
            <p className="fma">
                {( devis.fma?.error )? <><b>Erreur FMA - </b> {devis.fma.error}</> : ''}
            </p>
            <div className={this.state.waiting ? 'details waiting' : 'details'}>
            <table className="tarifs">
                <thead>
                    <tr><th colSpan="4" className="tarifs_head">Tableau des tarifs sans options.</th></tr>
                    <tr><th colSpan="4">
                        <span>Xenassur</span> / <span className="solly">SollyAzar</span> / <span className="maxance">Maxance</span> / <span className="axa">AXA</span> / <span className="fma">FMA</span>
                    </th></tr>
                    <tr><th>Annuel</th>{hasMaxance?<th>Annuel acompte<sup>(4)</sup></th>:<></>}{(hasAxa||hasFma)?<th>Coût annuel<br/>en mensuel</th>:<></>}<th>Mensuel lissé<sup>(1)</sup></th><th>Mensuel acompte<sup>(2)</sup></th><th>Mensuel<sup>(3)</sup></th></tr>
                </thead>
                <tbody>
                    {rows}
                    <tr><td colSpan="3">
                    <ul>
                        <li><b>(1) Mensuel lissé :</b> coût moyen par mois si périodicité mensuelle</li>
                        <li><b>(2) Mensuel acompte :</b> acompte si périodicité mensuelle : <br/>
                            <span className="xena">frais + 2 premiers mois</span><br/>
                            <span className="solly">frais + premier mois</span><br/>
                            <span className="maxance">frais comptant (dont frais de gestion ABP non récurrents) + fin du premier mois (le tarif indiqué correspond au mois complet, l'acompte réel est donc inférieur)</span></li>
                        <li><b>(3) Mensuel :</b> prix mensuel <br/>
                            <span className="xena">à partir du 3ème mois</span><br/>
                            <span className="solly">à partir du 2ème mois</span><br/>
                            <span className="maxance">à partir du 2ème mois</span></li>
                        {hasMaxance?<li><b>(4) Annuel acompte :</b> acompte si périodicité annuelle : <br/>
                            <span className="xena">identique au coût annuel</span><br/>
                            <span className="solly">identique au coût annuel</span><br/>
                            <span className="maxance">sur la première année, les frais de gestion non récurrents remplacent les frais termes</span></li>:<></>}
                    </ul>
                    </td></tr>
                </tbody>
            </table>
            <RightButtons {...this.props}/>
        </div>
        </React.Fragment>
    }
}

Tarifs.xenaWarranties = {
    M2:'Responsabilit? Civile, Casque, Gants, Gilet AIRBAG, DPRSA, PJ',
    M3:'M2 + Vol et Incendie',
    M4:'M3 + Dommages Collision (accident avec un tiers identifié)',
    M7:'M3 + Dommages Tous Accidents',
    L1:'Responsabilité Civile + DPRSA + PJ',
    L2:'L1 + Vol et Incendie + Bris de glace',
    L3:'L2 + Dommages Tous Accidents'
}

export default Tarifs;